import { connect } from 'react-redux';
import { BaseApp } from '../components';

function mapStateToProps(state) {
  return { step: state.scan.step };
}

export const AppContainer = connect(mapStateToProps)(BaseApp);

export default AppContainer;
